// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__zaqFf","header":"MessagesList_header__1Tc3Y","chat":"MessagesList_chat__2Mx0-"};